import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions } from "./actions";
import { type CheckoutButton } from "./types";

const reducer = (state: CheckoutButton.AppState = defaultState, action: ReduxAction<any>): CheckoutButton.AppState => {
  switch (action.type) {
    case Actions.AddToCartBegin: {
      return {
        ...state,
        status: Status.Saving
      };
    }
    case Actions.AddToCartFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.AddToCartSuccess: {
      return {
        ...state,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: CheckoutButton.AppState = {
  id: "",
  status: Status.None
};
export const previewState: CheckoutButton.AppState = {
  id: "",
  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState });
